export const trustedByConstants = {
  logoWidth: 206,
  logoHeight: 160,
  timePerLogo: 6,
  gap: 0,
}
